import * as actions from './artistActions'
import { combineReducers } from 'redux'

const infosInit = {}
const infos = (state = infosInit, action) => {
	switch (action.type) {
		case actions.GET_ARTIST_SUCCESS:
			if (action.infos) {
				return {
					id: action.infos.id,
					name: action.infos.name,
					nbDisques: action.infos.albums_count,
					description: action.infos.biography ? action.infos.biography.content : undefined,
					image: action.infos.image ? action.infos.image.large : undefined,
					hasTopTracks: action.topTracks && action.topTracks.total !== 0
				}
			}
			return infosInit
		default:
			return state
	}
}

const albumsInit = {}
const albums = (state = albumsInit, action) => {
	switch (action.type) {
		case actions.GET_ARTIST_SUCCESS:
			if (action.albums) {
				return {
					...action.albums,
					items: action.albums.items && action.albums.items.map(album => ({
						id: album.id,
						title: album.title,
						artist: album.artist ? {
							id: album.artist.id,
							name: album.artist.name
						} : undefined,
						image: album.image ? album.image.small : undefined,
						track_count: album.tracks_count,
						release_date_original: album.release_date_original,
						sampleable: album.sampleable,
						hires: album.hires,
						genre: album.genre
					}))
				}
			}
			return albumsInit
		default:
			return state
	}
}

export default combineReducers({
	infos,
	albums
})



// WEBPACK FOOTER //
// ./src/pages/artist/artistReducer.js